/** Branded local placeholder — never use via.placeholder.com in production */
export const VEHICLE_PLACEHOLDER_URL = `${process.env.PUBLIC_URL || ''}/images/vehicle-placeholder.svg`;
